import React from 'react';
import { useOnClickOutside } from '../Helpers/useOnClickOutside';
import { useRef } from 'react';

function PopupWitUseClickOutside(props) {
	const { isPopupVisible, onHidePopup, children } = props;
	const ref = useRef();
	useOnClickOutside(ref, () => onHidePopup());

	return (
		<div>
			{isPopupVisible ? (
				<div className="grid grid cols-1">
					<div
						className="fade absolute top-20 md:w-2/3 lg:w-1/3 h-auto justify-self-center z-50"
						ref={ref}
					>
						{children}
					</div>
					<div className="fixed top-0 left-0 w-full h-full bg-black opacity-80 grid grid cols-1 z-25" />
				</div>
			) : null}
		</div>
	);
}

export default PopupWitUseClickOutside;
